// export const BASE_URL = "http://192.168.1.12:8081/mtn-ftth-api/";
export const BASE_URL = "https://fibre.mtn.ci/mtn-ftth-api/";
// export const BASE_URL = "http://10.20.0.12:8080/mtn-ftth-api/";
// export const BASE_URL = "https://testmomoagent.mtn.ci/mtn-ftth-api/";
export const LOGIN_ENDPOINT = "/signin";
//////////////USER////////////////////////////////
export const USER_LIST = "/commerciale/user/rechercherusers";
export const ADD_USER = "/commerciale/user/enregistrer";
export const EDIT_USER= "/commerciale/user/modifier"
export const DISABLE_USER = "/commerciale/user/desactiver";
export const DELETE_USER = "/commerciale/user/supprimer";
export const EDIT_USER_CREDENTIALS = "/commerciale/user/modifieridentifiant"
export const FORGOT_PASSWORD = "/webfree/user/motdepasseoublie"
export const RESET_PASSWORD = "/webfree/user/renitialiserpassword"
export const EDIT_USER_PASSWORD = "/commerciale/user/modifiermotdepasse"
export const EDIT_PROFIL = "/commerciale/user/modifierprofile"
//////////////////////////////////////////////////////

    
///////////IDENTIFICATION/////////////////////////////
export const IDENTIFICATION = "/commerciale/abonnement/rechercheridentification";
export const LIST_IDENTIFICATION = "/commerciale/identification/rechercheridentifications";
///////////////////////////////////////////////////////


///////////AGENT////////////////////////////////////////
export const AGENT_LIST = "/commerciale/agent/rechercheragents";
export const ADD_AGENT = "/commerciale/agent/enregistrer";
export const EDIT_AGENT = ""
export const DISABLE_AGENT = "/commerciale/agent/desactiver";
export const DELETE_AGENT = "/commerciale/agent/supprimer";
export const AGENT_BY_PROFIL = "/commerciale/agent/rechercherlistagent";
///////////////////////////////////////////////////////////


///////////////CRENEAU//////////////////////////////////
export const LIST_CRENEAU = "/commerciale/crenau/recherchercrenaux";
export const ADD_CRENEAU = "/commerciale/crenau/enregistrer";
export const UPDATE_CRENEAU = "/commerciale/crenau/modifier";
export const DELETE_CRENEAU = "/commerciale/crenau/supprimer";
export const DISABLE_CRENEAU = "/commerciale/crenau/desactiver";
export const CRENEAU_DISPO = "/commerciale/creneau/recherchercreneauxdispo";
/////////////////////////////////////////////////////////


//////////////////////BATIMENT//////////////////////////////////
export const LIST_BATIMENT = "/commerciale/batiment/rechercherbatiments";
export const UPDATE_BATIMENT = "/commerciale/batiment/modifier";
export const ADD_BATIMENT = "/commerciale/batiment/enregistrer";
export const DELETE_BATIMENT = "/commerciale/batiment/supprimer";
/////////////////////////////////////////////////////////////////


//////////////////////EQUIPEMENT//////////////////////////////////
export const LIST_EQUIP = "/commerciale/equipement/rechercherequipements";
export const UPDATE_EQUIP = "/commerciale/equipement/modifier";
export const ADD_EQUIP = "/commerciale/equipement/enregistrer";
export const DELETE_EQUIP = "/commerciale/equipement/supprimer";
/////////////////////////////////////////////////////////////////

///////////////////Forfait////////////////////////////////////////
export const LIST_FORFAIT = "/commerciale/forfait/rechercherforfaits";
export const DELETE_FORFAIT = "/commerciale/forfait/supprimer";
export const ADD_FORFAIT = "/commerciale/forfait/enregistrer";
export const UPDATE_FORFAIT = "/commerciale/forfait/modifier";
export const FORFAIT_PAR_EQUIPE = "/commerciale/forfait/rechercherforfaitparequipement"
/////////////////////////////////////////////////////////////////

//////////////////////Intention////////////////////////////////
export const LIST_INTENTION = "/commerciale/abonnement/rechercherabonnements";
export const ADD_INTENTION = "/commerciale/abonnement/enregistrer";
export const RENDEZ_VOUS = "/commerciale/rendezvous/enregistrer";
export const CONFIRME_INTENTION = "/commerciale/abonnement/confirmerintention";
export const EDIT_ABONNEMENT = "/commerciale/abonnement/modifier";
/////////////////////////////////////////////////////////////


//////////////////Livraison///////////////////////////////////
export const LIST_LIVRAISON = "/commerciale/livraison/rechercherlivraison";
export const ADD_LIVRAISON = "/commerciale/livraison/enregistrer";
export const GENERATE_CODE_LIVRAISON = "/commerciale/livraison/generercodeconfirmation";
export const BORDEREAU_LIVRAISON = "/webfree/livraison/telechargerbroderau";
export const MODIFIER_LIVRAISON = "/commerciale/modifiernumeroftth";
////////////////////////////////////////////////////////////


///////////////////Paiement////////////////////////////////
export const LIST_PAIEMENT = "/commerciale/paiement/rechercherpaiementsparagent";
export const ADD_PAIEMENT = "/commerciale/paiement/enregistrerpaiement";
export const VERFIF_PAIEMENT = "/commerciale/paiement/verifierstatutpaiement";
export const CHECK_IS_FREE = "/commerciale/paiement/rechercherpaiementfree";
export const CHARGER_FICHIER = "/commerciale/paiement/chargerrecupaiement";
export const TELECHARGEMENT_RECU = "/webfree/paiement/telechargerrecupaiement";
///////////////////////////////////////////////////////////////////////


///////////////////////////RENDEZ-VOUS///////////////////////////////
export const MODIFIER_RENDEZ_VOUS = "/commerciale/rendezvous/modifier";
export const LIST_RDV = "/commerciale/rendezvous/rechercherrendezvous";
export const RENDEZ_VOUS_PAR_STATUS = "/commerciale/rendezvous/rechercherrendezvousparstatusabonnement";
///////////////////////////////////////////////////////////////////////////////


//////////////////////////////RACCORDEMENT///////////////////////////
export const LIST_RACCORDEMENT = "/commerciale/raccordement/rechercherraccordements";
export const DETAIL_RACCORDEMENT = "/commerciale/raccordment/rechercherDetails";
export const UPDATE_RACCORDEMENT = "/commerciale/raccordement/modifier";
////////////////////////////////////////////////////////////////////////////////


///////////////////////////////SURVEY/////////////////////////////////
export const LIST_SURVEY = "/commerciale/survey/recherchersurveys";
export const UPDATE_SURVEY = "/commerciale/survey/modifier";
export const SURVEY_PAR_TYPE = "/commerciale/rendezvous/rechercherrendezvouspartyperdv";
/////////////////////////////////////////////////////////////////////////////////////////


////////////////////////////SOUSCRIPTION//////////////////////////////
export const SOUSCRIPTION = "/commerciale/souscription/enregistrer";
export const RECUPERE_SOUSCRIPTION = "/commerciale/souscription/recuperersouscription";
export const LIST_SOUSCRIPTION = "/commerciale/souscription/recherchersouscriptions";
export const VERFIF_SOUSCRIPTION= "/commerciale/souscription/recherchercategoriesosucription"
/////////////////////////////////////////////////////////////////////////////////


////////////////////////////////TEST/////////////////////////////////////
export const TEST_SOUSCRIPTION = "/commerciale/test/enregistrer";
export const LIST_TEST = "/commerciale/test/recherchertests";
///////////////////////////////////////////////////////////////////////////


/////////////////////////////////////ACTIVATION////////////////////////////////
export const ACTIVATION = "/commerciale/activation/enregistrer";
export const LIST_ACTIVATION = "/commerciale/activation/rechercheractivations";
////////////////////////////////////////////////////////////////////////////


///////////////////Zone//////////////////////////////////////////////
export const RECUPERER_ZONE_COUVERTURE = "/webfree/zonecouverture/rechercherfichier";
export const RECUPERER_ZONE_COVERTURE_FICHIER = "/webfree/zonecouverture/rechercherzone";
export const ADD_ZONE_COUVERTURE = "/commerciale/zonecouverture/enregistrer";
export const ZONE_COUVERTURE = "/webfree/fichier/chargerfichier";
//////////////////////////////////////////////////////////////////////////


///////////////////Tableau de board////////////////////////////////
export const RECUPERER_DATA_COUNTER = "/commerciale/abonnement/rechercherstatsdashboard";
export const RECUPERE_GRAPHE_CHIFFRE_AFFAIRE = "/commerciale/paiement/recherchergraphechiffreaffaire";
export const RECUPERE_GRAPHE_INSTALLATION = "/commerciale/abonnement/recherchergraphetotalabonnement";
//////////////////////////////////////////////////////////


////////////////////////////////STATISTIQUE///////////////////////////////
export const COURBE = "/commerciale/abonnement/recherchergrapheglobal";
export const STATS_COUNTER_SURVEY = "/commerciale/rendezvous/rechercherstatsrendezvous";
//////////////////////////////////////////////////////////////////////////


///////////////////////////////////EQUIPE/////////////////////////////
export const ADD_TEAM = "/commerciale/equipe/enregistrer";
export const LIST_TEAM = "/commerciale/equipe/rechercherequipes";
export const DELETE_AGENT_BY_TEAM = "/commerciale/equipe/retirertechnicien/";
export const EQUIPE_DISPO = "/commerciale/equipe/rechercherequipesdispo";
export const LISTE_EQUIPE_SANS = "/commerciale/equipe/recherchertechniciensansequipe";
export const TECHNICIEN_PAR_EQUIPE = "/commerciale/equipe/recherchertechnienparequipe";
export const DISABLE_TEAM = "/commerciale/equipe/desactiver";
export const EDIT_TEAM = "/commerciale/equipe/modifier";
export const RETIRER_TECHNICIEN = "/commerciale/equipe/retirertechnicien";
///////////////////////////////////////////////////////////////////////////////////////


//////////////////////COMMENTAIRE///////////////////////////////////////////////
export const LIST_COMMENTAIRE = "/commerciale/typecommentaire/recherchertypescommentaire";
export const ADD_COMMENTAIRE = "/commerciale/typecommentaire/enregistrer";
export const DELETE_COMMENTAIRE = "/commerciale/typecommentaire/supprimer";
export const UPDATE_COMMENTAIRE = "/commerciale/typecommentaire/modifier";
//////////////////////////////////////////////////////////////////////////////////////


////////////////////////////////////////////OPERATION///////////////////////////
export const TOTAL_OPS = "/commerciale/totaleoperation/enregistrer";
export const GET_TOTAL_OPS = "/commerciale/totaleoperation/recherchertotaloperationparjour";
////////////////////////////////////////////////////////////////////////////////////////


////////////////////////ELIGIBILITE/////////////////////////////
export const LIST_ELIGIBILITE = "/commerciale/eligibilte/recherchereligibilites";
export const VERIFICATION_ELIGIBILITE = "/webfree/eligibilite/verifier";
export const VERIFICATION_PAR_LOT = "/commerciale/eligibilite/verifierlisteligibilites";
///////////////////////////////////////////////////////////////////////


////////////////////////////////MENU ET PERMISSION//////////////////////////
export const LIST_MENU = "/commerciale/rolepermission/rechercherlistmenus";
export const ADD_PERM = "/commerciale/permission/enregistrer";
export const RECHERCHER_PERM = "/commerciale/rolepermission/rechercherlistactionsparrole";
/////////////////////////////////////////////////////////////////////////////////


///////////////////////////PBO///////////////////
export const LIST_PBO = "/commerciale/pbo/rechercherpbos";
export const ADD_PBO = "/commerciale/pbo/enregistrer ";
export const UPDATE_PBO = "/commerciale/pbo/modifier"
export const DELETE_PBO = "commerciale/pbo/supprimer";
export const CHARGER_FICHIER_PBO = "/commerciale/pbo/enregistrerparlot";
export const PBO_DISPO = "/commerciale/pbo/rechercherpbodispo"
export const DISTANCE_PBO_ADD = "/commericiale/pbo/enregistrerdistance"
export const DISTANCE_PBO = "/commericiale/pbo/rechercherdistance"
export const COUPLEUR_PAR_PBO = "/commerciale/coupleur/recherchercoupleurs"
//////////////////////////////////////////////////////////////////////


////////////////////////////ZONE DE COUVERTURE///////////////
export const FICHIER_ZONE_COUVERTURE = "/webfree/zonecouverture/rechercherzone";
/////////////////////////////////////////////////////////////////////////////


/////////////////////////BRIN//////////////////////////////
export const PBO_LIST_BRIN = "/commerciale/brin/rechercherbrinsparpbo";
export const ADD_BRIN = "/commerciale/brin/enregistrer";
export const UPDATE_BRIN = "/commerciale/brin/modifierstatus";
export const DELETE_BRIN = "/commerciale/brin/supprimer";
export const EDIT_BRIN = "/commerciale/brin/modifier";
//////////////////////////////////////////////////////////////////////


/////////////////////////COUPLEUR//////////////////////////////
export const ADD_COUPLEUR = "/commerciale/coupleur/enregistrer";
export const UPDATE_COUPLEUR = "";
export const DELETE_COUPLEUR = "";
//////////////////////////////////////////////////////////////////////

/////////////////////////////////////ROLE///////////////////////
export const LISTE_ROLE = "/commerciale/role/rechercherlistroles";
export const ADD_ROLE = "/commerciale/role/enregistrer";
export const DELETE_ROLE = "/commerciale/role/supprimer";
export const EDIT_ROLE = "/commerciale/role/modifierrole"
///////////////////////////////////////////////////////////////////


////////////////////////PLANIFICATION///////////////////////////////
export const DELETE_PLANING = "/commerciale/planning/supprimer";
export const LIST_PLANING = "/commerciale/planning/rechercherplannings";
export const EDIT_PLANING = "/commerciale/planning/modifier";
export const FAIRE_PLANING = "/commerciale/planning/enregsitrer";
export const DATE_DISPO = "/commerciale/planning/rechercherdatesdispo";
////////////////////////////////////////////////////////////////////


//////////////////////////////SLA/////////////////////////////////////
export const SLA_INDICATOR_LIST = "/commericiale/sla/recherchersla"
export const UPDATE_INDICATOR_SLA = "/commerciale/sla/enregistrer"

////////////////////////////FICHIER/////////////////////////////
export const FICHIER_DOWNLOAD = "/webfree/fichier/telechargerfichier"
export const FICHIER_ABONNEMENT = "/commerciale/abonnement/charger-ficher-abonnements"
///////////////////////////RAPPORT////////////////////////////////
export const RAPPORT_PAIEMENT = "commerciale/abonnement/export-to-excel"